
import { useUnifiedAuth } from '@/contexts/auth/UnifiedAuthProvider';

// Re-export the unified auth hook for consistency across the app
export const useAuth = () => {
  return useUnifiedAuth();
};
